import { useApiService } from "services/ApiService";
import { ReportSetCommand } from "commands/reports/ReportSetCommand";
import { ReportPromptCommand } from "commands/reports/ReportPromptCommand";
import { ReportHallOfFameGameCommand } from "commands/reports/ReportHallOfFameGameCommand";
import { ReportImageCommand } from "commands/reports/ReportImageCommand";

export const ReportsApiService = () => {
    const { post } = useApiService({ controller: "/reports" });

    return {
        reportSet: (command: ReportSetCommand) => post("/set", command),
        reportPrompt: (command: ReportPromptCommand) => post("/prompt", command),
        reportHallOfFameGame: (command: ReportHallOfFameGameCommand) => post("/hall-of-fame-game", command),
        reportImage: (command: ReportImageCommand) => post("/image", command),
    };
};
